import { FC, useState } from 'react'
import Swal from 'sweetalert2'
import { setMerchantDepositSupersede } from './api'

interface Props {
  merchantId: number
  enabled: boolean
}

const MerchantDepositSupersede: FC<Props> = ({ merchantId, enabled }) => {
  const [on, setOn] = useState(enabled)
  const [busy, setBusy] = useState(false)

  const save = async (next: boolean) => {
    setBusy(true)
    try {
      const res = await setMerchantDepositSupersede(merchantId, next)
      if (!res?.data?.success) {
        throw new Error('save_failed')
      }
      Swal.fire({ toast: true, position: 'top', icon: 'success', title: 'Сохранено', showConfirmButton: false, timer: 2000 })
    } catch (e) {
      setOn(!next)
      Swal.fire({ toast: true, position: 'top', icon: 'error', title: 'Не удалось сохранить', showConfirmButton: false, timer: 3000 })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
      <input
        id='deposit-supersede'
        aria-label='Гашение дублей депозитов клиента'
        className='form-check-input'
        type='checkbox'
        checked={on}
        disabled={busy}
        onChange={() => {
          const next = !on
          setOn(next)
          save(next)
        }}
      />
      <label htmlFor='deposit-supersede' className='form-check-label'>
        {on ? 'Включено' : 'Выключено'}
      </label>
    </div>
  )
}

export default MerchantDepositSupersede
